export const selectInvoiceSearchStatus = (state) => state.invoiceSearch?.status;

export const selectInvoiceSearchResults = (state) =>
  state.invoiceSearch?.data || [];

export const selectStoredMeta = (state) => state.invoiceSearch?.meta || {};

export const selectInvoicesSearchTotals = (state) =>
  state.invoiceSearch?.totals || {};

export const selectItemsPerPage = (state) =>
  state.invoiceSearch?.tableItemsPerPage;

export const selectTableSort = (state) => state.invoiceSearch?.tableSort;

export const selectTableCurrentPage = (state) =>
  state.invoiceSearch?.tableCurrentPage;

export const selectStoredPayload = (state) =>
  state.invoiceSearch?.storedPayload || {};

export const selectInvoiceBeingApprovedId = (state) =>
  state.invoiceSearch?.approveInProgressId;

export const selectInvoicePaymentURL = (state) =>
  state.invoiceSearch?.paymentLink;

export const selectInvoicesOpeningList = (state) =>
  state.invoiceSearch?.invoicesOpeningList;

export const selectInvoicesDownloadingList = (state) =>
  state.invoiceSearch?.invoicesDownloadingList;

export const selectInvoicesSendingList = (state) =>
  state.invoiceSearch?.invoicesSendingList;

export const selectFile = (state) => state.invoiceSearch?.file;

export const selectDownloadDocumentsIsLoading = (state) =>
  state.invoiceSearch?.downloadDocumentsIsLoading;
